import { getPropertyOf, Lookup } from '@cs/core';

export class ViewSelectionItem {
  /**
   * If there is a need for a label
   */
  label: string | null;
  /**
   * the possible selections
   */
  lookup: Lookup;
  /**
   * Name of the property
   */
  id: string;
  /**
   * the key of the selected item {@link(Lookup.values)}
   */
  selected: string | number;
	/**
   * Description of the property
   */
	description: string;

  constructor(init: Partial<ViewSelectionItem>) {
    this.id       = getPropertyOf(init, 'id');
    this.label    = getPropertyOf(init, 'label', null);
    this.lookup   = getPropertyOf(init, 'lookup');
    this.selected = getPropertyOf(init, 'selected');
		this.description = getPropertyOf(init, 'description', '');
  }
}
